<template>
    <app-layout title="Gebruikers">
        <template #header>
            <page-title title="Gebruikers" />
        </template>

        <template #pageContent>
            <div id="users">
                <h2>Filters</h2>
                <Form>
                    <div class="grid grid-cols-2 gap-2">
                        <Select name="role" :options="role_list" v-model="form.role" class="flex-1" placeholder="Selecteer een rol" :emptyOption="true" label="Rol" layout="vertical" @change="filter"/>
                        <Select name="permission" :options="permissions" v-model="form.permission" class="flex-1" placeholder="Selecteer een recht" :emptyOption="true" label="Recht" layout="vertical" @change="filter"/>
                        <Input label="In dienst op (vanaf)" name="activate_on_start" v-model="form.activate_on_start" layout="vertical" type="date" @change="filter"/>
                        <Input label="In dienst op (tot)" name="activate_on_end" v-model="form.activate_on_end" layout="vertical" type="date" @change="filter"/>
                        <Input label="Uit dienst op (vanaf)" name="deactivate_on_start" v-model="form.deactivate_on_start" layout="vertical" type="date" @change="filter"/>
                        <Input label="Uit dienst op (tot)" name="deactivate_on_end" v-model="form.deactivate_on_end" layout="vertical" type="date" @change="filter"/>
                    </div>
                </Form>
                <h2>Alle gebruikers</h2>
                <Input type="search" placeholder="Gebruiker zoeken" v-model="searchUser" name="search-user" />
                <Table id="users-overview" :values="filteredUsers" :pageSize="10">
                    <thead>
                    <Th id="name">Naam</Th>
                    <Th id="username">Gebruikersnaam</Th>
                    <Th id="email">Email</Th>
                    <Th id="function">Functie</Th>
                    <Th id="status">Status</Th>
                    <Th :sort="false">Rollen</Th>
                    <Th :sort="false">Rechten</Th>
                    <Th id="activate_on">In dienst op</Th>
                    <Th id="deactivate_on">Uit dienst op</Th>
                    <Th id="updated_at">Laatste wijziging</Th>
                    <Th :sort="false">
                        <Button
                            htmlType="a"
                            buttonClass="add"
                            size="small"
                            title="Gebruiker toevoegen"
                            text="Gebruiker toevoegen"
                            :href="route('admin.users.create')"
                        />
                    </Th>
                    </thead>
                    <tbody v-if="filteredUsers.length > 0">
                    <tr v-for="user in state.sortedValues['users-overview']" :key="user.id">
                        <Td>{{ user.name }}</Td>
                        <Td>{{ user.username }}</Td>
                        <Td>{{ user.email }}</Td>
                        <Td>{{ user.function }}</Td>
                        <Td>
                            <badge :text="user.status" v-if="user.status == 'active'"/>
                            <badge :text="user.status" v-else-if="user.status == 'pending'" badgeClass="warning"/>
                            <badge :text="user.status" v-else-if="user.status == 'blocked'" badgeClass="dark"/>
                            <badge :text="user.status" v-else badgeClass="danger"/>
                        </Td>
                        <Td>
                            <template v-for="role in user.roles">
                                <badge :text="role.name" v-if="role.slug == 'admin'" badgeClass="danger"/>
                                <badge :text="role.name" v-else-if="role.slug == 'it'" badgeClass="warning"/>
                                <badge :text="role.name" v-else-if="role.level > 0" badgeClass="dark"/>
                                <badge :text="role.name" v-else badgeClass="light"/>
                            </template>
                        </Td>
                        <Td>
                            <badge v-for="permission in user.user_permissions" :text="permission.name" badgeClass="dark"/>
                        </Td>
                        <Td>{{ user.activate_on }}</Td>
                        <Td>{{ user.deactivate_on }}</Td>
                        <Td>{{ moment(user.updated_at).format('DD/MM/YYYY HH:mm') }}</Td>
                        <Td>
                            <Button
                                htmlType="a"
                                buttonClass="show"
                                size="small"
                                title="Gebruiker bekijken"
                                text="Gebruiker bekijken"
                                :href="route('admin.users.show', {'id':user.id})"
                            /><br>
                            <Button
                                htmlType="a"
                                buttonClass="edit"
                                size="small"
                                title="Gebruiker aanpassen"
                                text="Gebruiker aanpassen"
                                :href="route('admin.users.edit', {'id':user.id})"
                            />
                        </Td>
                    </tr>
                    </tbody>
                </Table>
            </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Td from '@/Components/Td.vue'
import Th from '@/Components/Th.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Input from '@/Components/Input.vue'
import Badge from '@/Components/Badge.vue'
import Select from '@/Components/Select.vue'
import Form from '@/Components/Form.vue'

import { Link, useForm } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";

export default {
    components: {
        AppLayout,
        PageTitle,
        Link, Table,
        Td,
        Th,
        Button,
        Modal,
        Input,
        Badge,
        Select,
        Form
    },
    props:[
        'users',
        'role_list',
        'permissions',
        'role',
        'permission',
        'activate_on_start',
        'activate_on_end',
        'deactivate_on_start',
        'deactivate_on_end'
    ],
    data() {
        return {
            searchUser: '',
        };
    },
    setup (props){
        let form = useForm({
            'role': props.role,
            'permission': props.permission,
            'activate_on_start': props.activate_on_start,
            'activate_on_end': props.activate_on_end,
            'deactivate_on_start': props.deactivate_on_start,
            'deactivate_on_end': props.deactivate_on_end,
        })

        function filter(){
            form.get('/admin/users')
        }

        return {
            state: store.state,
            ...store,
            form,
            filter
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
        filteredUsers(){
            return this.users.filter(user => {
                return user.name.toLowerCase().includes(this.searchUser.toLowerCase()) ||
                    user.username.toLowerCase().includes(this.searchUser.toLowerCase()) ||
                    user.email.toLowerCase().includes(this.searchUser.toLowerCase()) ||
                    user.function.toLowerCase().includes(this.searchUser.toLowerCase())
            })
        },
    },
}

</script>
